<template>
    <div class="templete">
        <div class="search_box clearfix">
            <el-select class="search_select search_inputBox" width="130px !important" v-model="contract_type" placeholder="融资合同" @change="changePurchase_id" @visible-change="getSelectList('pledgePurchase')">
                <el-option v-for="item in selectMap.pledgePurchase" :key="item.id" :value="item.name+'~'+item.id"  :label="item.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="apObj.redeem_category==1" v-model="params.finance_order_id" placeholder="关联融资提单号" @visible-change="getPledgeOrderList(contract_id)">
                <el-option v-for="list in pledgeOrderList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-input class="search_input search_inputBox" v-model="params.contract_no" @keyup.enter.native="getList(true)" placeholder="采购合同号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.finance_order_id" placeholder="融资单号" @change="finceChage">
                <el-option v-for="list in pledgeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" @keyup.enter.native="getList(true)" placeholder="提单号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.container_no" @keyup.enter.native="getList(true)" placeholder="货柜号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
            </div>
        </div>
        <div class="tableBox selectStockTable">
            <!-- <tabletem :isSetCol="true" scene="select.pledge.stock.list" :isLoading="tableLoading" :ref="tableList" :tablecol="tableCol" :tabledata="list" @sortTable="sortTable" @getRow="getRow" @rowClick="rowClick"></tabletem> -->
             <el-table :data="list" ref="listDetailTable"  border stripe highlight-current-row  size="mini" height="100%" @header-dragend="headDrog" @selection-change="selectionChange"  @row-click="toggleSelection">
                <!-- <el-table-column type="index" label="序号" align="center" width="50"></el-table-column> -->
                <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column>
                <template v-for="(item) in filter">
                    <el-table-column :prop="item.field" v-if="item.show && tableCol.indexOf(item.field)" :key="item.field" :label="item.name"
                                :sortable="false"
                                :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                align="left"
                                show-overflow-tooltip
                            >
                        <template slot-scope="scope">
                            <div v-if="item.field == 'original_width_total'">
                                <span @click="widthObj.widthList = JSON.parse(JSON.stringify(scope.row.width));dialogVisibleWidth=true;isCanEditTotalWidth=false;widthObj.widthType=''" style="text-decoration:underline;cursor:pointer;">
                                    {{ scope.row.original_width_total }}
                                </span>
                            </div>
                            <span v-else id="ceshidom">
                                {{ scope.row[item.field] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="btnList clearfix">
            <div class="totalBox">
                <div class="total">选中件数：{{totalNumber}}件</div>
                <div class="total">选中方数：{{totalCube}}</div>
            </div>
            <div class="btnBox">
                <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                <el-button  class="funcPublicBtn" @click="selectData">选中</el-button>
                <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
            </div>
        </div>
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="select.pledge.stock.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue'
    import pagination from '../../../../components/pagination.vue'
    export default {
        props: {
            apParams: {
                type:Object,
            },
        },
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                apObj: this.apParams,
                params:{
                    // issuing_id:"",
                    contract_no:'',
                    // finance_order_id:'',
                    // bill_lading_no:'',
                    // container_no:'',
                    // breed_id:'',
                    // thickness:'',
                    // length:'',
                    // contract_no_id:'',
                    finance_order_id:'',
                    per_page:50,
                    page:1
                },
                last_page:1,
                total:0,
                totalNumber:0,
                totalCube:0,
                selectRow:[],
                selectMap:{
                    pledgeOrdersn:[],
                    pledgePurchase:[]
                },
                selectMapC:{
                    breed_id:[],
                    original_thickness:[],
                    original_length:[],
                },
                statusList:[],
                pledgeList:[],
                widthList:[],
                list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"融资合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"finance_order_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"index_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"index_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"融资单价",colKey:"cube_price",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"资源状态",colKey:"finance_bale_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"融资单号",colKey:"finance_order_sn",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                contract_type:'',
                contract_id:'',
                pledgeOrderList:[]
            }
        },
        created(){
            this.postFunc("/erp/select.pledge.ordersn",{issuing_id:this.apObj.issuing_id},res=>{
                this.pledgeList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filter.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + 'select.pledge.stock.list').replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            selectionChange(row){
                this.selectRow=row;
                this.totalNumber=this.selectRow.length;
                this.totalCube=0;
                this.selectRow.forEach(item=>{
                    this.totalCube+=Number(item.sales_cube);
                })
                this.totalCube=this.keepLimit(this.totalCube)
            },
            checkSelectable(row){
                return true;
            },
            toggleSelection(row) {
                this.$refs.listDetailTable.toggleRowSelection(row);
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube: 4,//码单立方
                },total=>{
                });
            },
            getBillColumn(){
                let {columnType} = this.$data;
                this.filterA =[]
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    if(columnType.indexOf(1)!=-1){
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filterA = response.data.data.columns;
                    } 
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            changePurchase_id(e){
                var str = this.contract_type;
                this.params.contract_no = str.substring(0, str.indexOf("~"));
                var index=str.lastIndexOf("\~");
                this.contract_id=str.substring(index+1,str.length);
                this.pledgeOrderList =[];
                this.params.finance_order_id=''
            },
            getPledgeOrderList(contract_id){
                this.postFunc('/erp/pledge.order.option',{purchase_id:contract_id},res=>{
                    this.pledgeOrderList = res.data.data
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                // spots
                this.$getSelectWarehouseList(target,this.params,"","sales").then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            cancel(){
                this.$emit("cancel")
            },
            selectData(){
                this.$emit("selectData",this.selectRow)
            },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.params=this.resetSearch(this.params);
                this.contract_type = '';
                this.contract_id = '';
                this.getList();
            },
            getList(flag){
                console.log(this.$refs,123)
                console.log(this.$refs.tableList,4556)
                this.$nextTick(() => {
                    
                    // this.$refs.tableList.toggleRowSelection(
                    //     this.list[i],
                    //     true
                    //     );
                    // for (let i = 0; i < this.list.length; i++) {
                        
                    // }
                });
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.issuing_id = this.apObj.issuing_id;
                this.$postColumnList("/erp/select.pledge.stock.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,ind)=>{
                        if(item.inbound_time){
                            this.list[ind].inbound_time = this.formatTime(this.list[ind].inbound_time+"000")
                        }else{
                            this.list[ind].inbound_time = "";
                        }
                        item.baseColor = "";
                        //this.list[ind].original_width_total = parseInt( this.list[ind].original_width_total);
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                        // if((((item.status==1||item.status==0)&&item.lock_status==0)&&item.check_rule == 0)&&item.sales_select==1){
                        //     item.isCanSelection=false;
                        // }else{
                        //     item.isCanSelection=true;
                        // }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"||item.colKey=="stock_status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                    if(this.params.contract_no!=''){
                        this.$nextTick(() => {
                            for (let i = 0; i < this.list.length; i++) {
                                this.$refs.listDetailTable.toggleRowSelection(
                                this.list[i],
                                true
                                );
                            }
                        });
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            getRow(row){
                this.selectRow=row;
                this.totalNumber=this.selectRow.length;
                this.totalCube=0;
                this.selectRow.forEach(item=>{
                    this.totalCube+=Number(item.sales_cube);
                })
                this.totalCube=this.keepLimit(this.totalCube)
            },
            resetSelect(){
                this.reset()
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "apParams": {
                handler(val) {
                    this.apObj = val;
                    // this.dialogTitle = '选择货物   （金融提供方：' + this.apObj.finance_provider_name + '）';
                    if (Object.keys(this.apObj).length > 0) {
                        this.getList();
                    }
                },
            },
        },
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>